export default __webpack_public_path__ + "static/media/2022Icon.27efe212.png";